import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import _ from "lodash";
import jslinq from "jslinq";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ItemsCarousel from "@/components/ItemsCarousel.vue";
import config from "@/config/custom-config";
let Aste = class Aste extends Vue {
  constructor() {
    super(...arguments);
    this.itemsType = "aste";
    this.sizes = [];
    this.activeTemple = {};
    this.metalTemplesNotification = false;
    this.baseAcetatePath = "";
    this.baseStandardPath = "";
    this.materiale = "PL";
    this.animateTemplesColors = false;
    this.animateTemplesSize = false;
    this.animateTemplesMaterial = false;
    this.text = "";
    this.internalChange = false;
    this.materialOptions = [{
      text: 'Plastica',
      id: 'PL'
    }, {
      text: 'Metallo',
      id: 'MT'
    }];
    this.colorMetalOptions = ['GUN', 'GOLD'];
    this.finituraOptions = [];
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = true;
    this.scrollCounter = 0;
  }
  async mounted() {
    await this.getColors();
    this.temples;
    this.finituraOptions = [{
      id: "S",
      text: "Lucido"
    }, {
      id: "M",
      text: "Opaco"
    }];
  }
  get config() {
    return config;
  }
  get templesColor() {
    return this.$store.getters["configurator/templesColor"];
  }
  get activeTempleCode() {
    const asta = this.$store.state.configurator.coloreAste;
    if (asta) {
      const matchingTemple = this.filteredTemples.find(t => t.U_THE_COLORE === asta.U_THE_COLORE);
      if (matchingTemple) {
        return matchingTemple.ItemCode;
      }
    }
    return null;
  }
  set templesColor(value) {
    this.$store.commit("configurator/setTemplesColor", value);
  }
  get templesSize() {
    if (this.$store.state.configurator.lungAste) {
      return this.$store.state.configurator.lungAste;
    } else {
      return "145";
    }
  }
  set templesSize(value) {
    this.$store.state.configurator.lungAste = value;
  }
  get templesFinishing() {
    if (this.$store.state.configurator.finituraAste) {
      return this.$store.state.configurator.finituraAste;
    } else {
      return "S";
    }
  }
  set templesFinishing(value) {
    this.$store.commit("configurator/setTemplesFinishing", value);
  }
  get templesMaterial() {
    return this.$store.state.configurator.templesMaterial;
  }
  set templesMaterial(value) {
    this.$store.commit("configurator/setTemplesMaterial", value);
  }
  get temples() {
    return this.$store.state.configurator.aste.allColors;
  }
  get dynamicMaterialOptions() {
    const materials = new Set();
    this.templesForLine.forEach(aste => {
      if (aste.materiale) {
        materials.add(aste.materiale);
      }
    });
    // Mappa i materiali a un array di oggetti per Vue Select
    return Array.from(materials).map(material => {
      return {
        id: material,
        text: this.getMaterialName(material)
      };
    });
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  unsetTemplesMetalColor() {
    this.$store.commit("configurator/unsetTemplesMetalColor");
  }
  get currentSubline() {
    var _this$$store$state$co;
    return (_this$$store$state$co = this.$store.state.configurator.frontale) === null || _this$$store$state$co === void 0 ? void 0 : _this$$store$state$co.U_THE_SOTTOLINEA;
  }
  materialLabel(item) {
    return item === 'MT' ? this.$t("message.metallo") : this.$t("message.plastica");
  }
  materialValue(item) {
    return item;
  }
  getMaterialName(materialId) {
    switch (materialId) {
      case 'PL':
        return this.$t("message.Plastica");
      case 'MT':
        return this.$t("message.Metallo");
      default:
        return '';
    }
  }
  getColors() {
    return this.$store.dispatch("configurator/aste/getAllColors");
  }
  getTempleImageUrl(t) {
    // recuper colori dalla cartella frontali perchè  nella cartella aste sono ruotate
    return process.env.VUE_APP_COLORS_URL + t.U_THE_COLORE + ".jpg";
  }
  setActiveTemple(t) {
    this.$store.state.configurator.coloreAste = t.U_THE_COLORE;
    this.activeTemple = t;
    this.templesMaterial = t.materiale && t.materiale != "" ? t.materiale : "PL";
    this.templesColor = t;
    // Setta il materiale corretto
    if (t.materiale == "MT") {
      // Se metallo, setta GUN o GOLD in base al colore attualmente selezionato
      this.coloreMetalloAste = t.U_THE_COLORE.endsWith("GUN") ? "GUN" : "GOLD";
    } else {
      // Se plastica, togli il metalColor se presente
      this.unsetTemplesMetalColor();
    }
    if (t.U_THE_LUNGASTA != this.templesSize && this.currentSubline != 'IG04TH') {
      this.templesSize = t.U_THE_LUNGASTA;
    }
  }
  isActive(t) {
    return this.activeTemple == t;
  }
  get sizeButtons() {
    return this.sizes.filter(size => {
      // @ts-ignore
      return this.sizesAvailables.indexOf(size) >= 0;
    });
  }
  get templesForLine() {
    if (!this.frontale) {
      console.warn("Frontale is not defined");
      return []; // o un array vuoto, se non vuoi restituire nulla
    }
    return this.temples.filter(t => {
      if (this.frontale.U_THE_LINEA === "HASHTAG") {
        // Se la linea è "HASHTAG", mostra solo le aste di tipo A
        return t.U_THE_SOTTOLINEA === "TIPO_A";
      } else if (this.frontale.U_THE_LINEA === "ULTEMATE") {
        // Se la linea è "HASHTAGBOLD", mostra solo le aste di tipo B
        return t.U_THE_SOTTOLINEA === "TIPO_G";
      } else {
        // In tutti gli altri casi, confronta la sottolinea
        return t.U_THE_LINEA == this.frontale.U_THE_LINEA;
      }
    });
  }
  get filteredTemples() {
    let result = this.temples;
    if (this.templesSize) {
      result = result.filter(t => {
        return t.U_THE_LUNGASTA == this.templesSize;
      });
    }
    //voglio che vengano mostrate solo le aste con la sottolinea uguale alla sottolinea del frontale
    if (this.currentSubline) {
      result = result.filter(t => {
        return t.U_THE_SOTTOLINEA == this.frontale.U_THE_SOTTOLINEA;
      });
    }
    // Filtra per finitura
    if (this.finituraAste === "S") {
      result = result.filter(t => t.U_THE_FINITURA === "NESSUNO");
    } else if (this.finituraAste === "M") {
      result = result.filter(t => t.U_THE_FINITURA === "M");
    }
    //voglio che la varibaile filteredtemples nello store sia uguale a result
    this.$store.commit("setFilteredTemples", result);
    if (this.activeTemple && this.activeTemple.U_THE_COLORE) {
      const matchingTemple = result.find(t => t.U_THE_COLORE === this.activeTemple.U_THE_COLORE);
      if (matchingTemple) {
        this.setActiveTemple(matchingTemple);
      }
    }
    return result;
  }
  get misuraAste() {
    return this.$store.state.configurator.misuraAste;
  }
  get finituraAste() {
    return this.$store.state.configurator.finituraAste;
  }
  set finituraAste(f) {
    this.templesFinishing = f;
  }
  get tintaUnita() {
    return this.$store.state.tintaUnita;
  }
  set tintaUnita(newVal) {
    this.$store.commit("setTintaUnita", newVal);
  }
  get finitura() {
    return this.$store.state.configurator.finitura;
  }
  get coloreMetalloAste() {
    return this.$store.state.coloreMetalloAste;
  }
  set coloreMetalloAste(c) {
    // TODO: vedere come gestire questa cosa in maniera più generica su configurator-base-app
    // perché PRO...272 e PRO...280 non c'entrano con iGreen
    this.$store.commit("configurator/setTemplesMetalColor", c == "GUN" ? "PRO0000272" : "PRO0000280");
    this.$store.commit("setTemplesMetalColor", c);
  }
  get sizesAvailables() {
    let temples = jslinq(this.temples);
    return temples.where(t => this.materiale == t.materiale).orderBy(t => t.U_THE_LUNGASTA).select(t => t.U_THE_LUNGASTA).distinct().toList();
  }
  noTempleAvailable() {
    if (this.filteredTemples.length == 0) {
      return true;
    } else {
      return false;
    }
  }
  onMaterialeChanged(newVal) {
    if (newVal == "MT") {
      this.templesSize = "143";
      this.templesFinishing = "M";
    }
  }
  onColoreMetalloAsteChanged(newVal) {
    /**
      Quando cambio colore del metallo
      sostituisco la porzione di nome necessaria
      per selezionare il colore se presente
    */
    let at = this.templesColor;
    let ma = "";
    if (!_.isEmpty(at)) {
      if (newVal != "GUN") {
        ma = at.U_THE_COLORE.replace("GUN", "GOLD");
      } else {
        ma = at.U_THE_COLORE.replace("GOLD", "GUN");
      }
      let a = this.temples.filter(t => {
        return t.U_THE_LUNGASTA == at.U_THE_LUNGASTA && t.U_THE_COLORE == ma;
      });
      if (a.length > 0) {
        this.setActiveTemple(a[0]);
      } else {
        if (this.filteredTemples.length != 0) {
          this.setActiveTemple(this.filteredTemples[0]);
        }
      }
    }
  }
  onFinituraAsteChanged(newVal) {
    let at = this.templesColor;
    let f = "";
    if (!_.isEmpty(at)) {
      if (newVal == "M") {
        if (at.U_THE_COLORE.charAt(0) == "0") {
          f = at.U_THE_COLORE.replace(at.U_THE_COLORE.charAt(0), "M");
        } else if (at.U_THE_COLORE.charAt(1) != "M" && at.U_THE_COLORE.charAt(0) == "L") {
          f = at.U_THE_COLORE.replace(at.U_THE_COLORE.charAt(0), "LM");
        } else {
          f = at.U_THE_COLORE;
        }
      } else {
        if (at.U_THE_COLORE.charAt(0) == "M") {
          f = at.U_THE_COLORE.replace(at.U_THE_COLORE.charAt(0), "0");
        } else if (at.U_THE_COLORE.charAt(0) == "L") {
          f = at.U_THE_COLORE.replace(at.U_THE_COLORE.charAt(1), "");
        } else {
          f = at.U_THE_COLORE;
        }
      }
      let a = this.temples.filter(t => {
        return t.U_THE_LUNGASTA == at.U_THE_LUNGASTA && t.U_THE_COLORE == f;
      });
      if (a.length > 0) {
        this.setActiveTemple(a[0]);
      } else {
        if (this.filteredTemples.length != 0) {
          this.setActiveTemple(this.filteredTemples[1]);
          // this.setActiveTemple('');
        }
      }
    }
    if (newVal) {
      if (this.finituraAste != this.finitura) {
        this.tintaUnita = false;
      }
    }
  }
  onTemplesColorChanged(newVal, oldVal) {
    if (newVal && (!oldVal || newVal.U_THE_COLORE != oldVal.U_THE_COLORE)) {
      this.activeTemple = newVal;
    }
  }
};
__decorate([Prop({
  default: false
})], Aste.prototype, "darkTheme", void 0);
__decorate([Watch("materiale")], Aste.prototype, "onMaterialeChanged", null);
__decorate([Watch("coloreMetalloAste")], Aste.prototype, "onColoreMetalloAsteChanged", null);
__decorate([Watch("finituraAste")], Aste.prototype, "onFinituraAsteChanged", null);
__decorate([Watch("templesColor")], Aste.prototype, "onTemplesColorChanged", null);
Aste = __decorate([Component({
  components: {
    ItemsCarousel
  }
})], Aste);
export default Aste;